import React from 'react';
import clsx from 'clsx';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../ui/accordion';

interface TabDataCardDropdownProps {
  label?: string | undefined;
  children: React.ReactNode;
}

export const TabDataCardDropdown = ({ label, children }: TabDataCardDropdownProps) => {
  return (
    <div className="p-2 rounded-xl border transition-colors bg-grey-300 border-grey-400 dark:bg-blue-900 dark:border-grey-600">
      <Accordion type="single" collapsible>
        <AccordionItem value={label ?? 'item-1'}>
          <AccordionTrigger
            className={clsx(
              'group flex w-full justify-between items-center text-left transition-colors rounded-lg p-2  bg-transparent hover:bg-blue-200 dark:hover:bg-blue-800'
            )}
          >
            {label}
          </AccordionTrigger>
          <AccordionContent className="p-2 mt-2 text-gray-700 dark:text-blue-100">{children}</AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
